import { render, staticRenderFns } from "./ManualWeekly.vue?vue&type=template&id=400929f7&scoped=true"
import script from "./ManualWeekly.vue?vue&type=script&lang=js"
export * from "./ManualWeekly.vue?vue&type=script&lang=js"
import style0 from "./ManualWeekly.vue?vue&type=style&index=0&id=400929f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400929f7",
  null
  
)

export default component.exports